import React, { FC } from 'react';
import { NavLink } from 'react-router-dom';

import { Routes } from '../../../../AppRoutes';
import { Icon } from '../../../../components';

const transferWrapper = (Component: FC<any>) => (props: any) => {
  return (
    <div className='transfer-wrapper'>
      <div className='TabLinks'>
        <NavLink to={Routes.transferList.path}>
          <Icon.User />
          <p className='d-none d-md-block'>Danh sách</p>
        </NavLink>

        <NavLink
          to={Routes.TransferToUser.path}
          // isActive={() => props?.location?.pathname === '/transfer/to-user'}
        >
          <Icon.KYC />
          <p className='d-none d-md-block'>Chuyển điểm</p>
        </NavLink>
      </div>

      <Component {...props} />
    </div>
  );
};

export default transferWrapper;
